import bModal from './modal.vue';

export default bModal;


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-vue/es/components/modal/modal.js
// module id = ESch
// module chunks = 0